// extracted by mini-css-extract-plugin
export default {"container":"Job_container__Yt3hy","title":"Job_title__SgpcA","feature":"Job_feature__6kYa9","description":"Job_description__HpEcC","skill":"Job_skill__GwSVe"};